export default function updateStore (state, data) {
  Object.keys(data).forEach(stateKey => {
    state[stateKey] = data[stateKey];
  });
}
